module.exports = __webpack_public_path__ + "static/media/unlock-alt.d71b7a57.svg";